/**
 * Returns an ApiClient instance from context..
 */
import { throwPlatformError, UIErrorCode } from '../../errors'
import { useApiClientContext } from './context'

export const useApiClient = () =>
  useApiClientContext() ??
  throwPlatformError(
    'Unable to find an ApiClient instance. Has Horizon Core been initialized in the current environment?',
    UIErrorCode.CORE_CONTEXT_NOT_FOUND,
  )
